export default __webpack_public_path__ + "static/media/ml.84fcec0f.JPG";